<template>
  <div class="pt-2 d-flex" style="overflow-y: hidden">
    <v-card flat class="d-flex flex-column flex-grow-1 flex-shrink-1">
      <v-form v-model="valid" class="flex-grow-0 flex-shrink-0">
        <v-row no-gutters align="center" justify="space-around">
          <v-col cols="12" sm="1" style="text-align: right">
            <label>事项编号:</label>
          </v-col>
          <v-col cols="12" sm="3">
            <v-text-field
              class="form-item-value"
              v-model="filter.itemCode"
              label=""
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="1" style="text-align: right">
            <label>事项名称：</label>
          </v-col>
          <v-col cols="12" sm="3">
            <v-text-field
              class="form-item-value"
              v-model="filter.name"
              label=""
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="1"></v-col>
          <v-col cols="12" sm="2">
            <v-btn color="primary" class="mr-2" depressed @click="handleSearch" v-if="_hasButtonPermission('查询')"
              >查询</v-btn
            >
            <v-btn depressed @click="handleResetSearch" v-if="_hasButtonPermission('查询')">重置</v-btn>
          </v-col>
        </v-row>
      </v-form>
      <div class="flex-grow-1 flex-shrink-1" style="position: relative">
        <div style="position: absolute; inset: 0px">
      <v-data-table
          ref="data"
        :headers="headers"
        fixed-header
          height="calc(100% - 64px - 59px)"
          style="height: 100%"
        :items="desserts"
        class="elevation-1 mt-2"
        :loading="loading"
        :server-items-length="totalDesserts"
        :page.sync="filter.pageNum"
        :items-per-page.sync="filter.pageSize"
        group-by="subjectName"
        show-group-by
        @update:page="handlePageChanged"
        @update:items-per-page="handlePageSizeChanged"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-btn color="primary" depressed class="mr-2" @click="doImport" v-if="_hasButtonPermission('导入')">
              导入
            </v-btn>
            <v-btn color="primary" depressed class="mr-2" @click="doExport" v-if="_hasButtonPermission('导出')">
              导出
            </v-btn>
            <v-btn color="primary" depressed class="mr-2" @click="doRatio" v-if="_hasButtonPermission('复检比例定义')">
              复检比例定义
            </v-btn>
          </v-toolbar>
        </template>

        <template v-slot:[`group.header`]="{ group,groupBy,isMobile,items,headers,isOpen,toggle,remove }">
          <td :colspan="headers.length" class="text-start">
            <v-btn class="ma-0" v-on:click="groupToggle(group)" small icon> <v-icon>{{isOpen?'$minus' : '$plus'}}</v-icon></v-btn>
            {{ getHeadTextByValue(groupBy) }}：{{group}}
          </td>
        </template>

        <template v-slot:[`item.type`]="{ item }">
          {{ item.type === 1 ? "自维" : "外委" }}
        </template>
        <template v-slot:[`item.cycle`]="{ item }">
          {{ item.cycle }}年
        </template>
        <template v-slot:[`item.status`]="{ item }">
          {{ item.status === 0 ? "禁用" : "启用" }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip bottom v-if="_hasButtonPermission('修改')">
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2" @click="editItem(item)" v-bind="attrs" v-on="on">
                mdi-pencil
              </v-icon>
            </template>
            <span>修改</span>
          </v-tooltip>
          <v-tooltip bottom v-if="item.status===1 && _hasButtonPermission('禁用')">
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-if="item.status===1" small @click="disableItem(item)" v-bind="attrs" v-on="on"> mdi-close-circle </v-icon>
            </template>
            <span>禁用</span>
          </v-tooltip>
          <v-tooltip bottom v-if="item.status===0 && _hasButtonPermission('启用')">
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-if="item.status===0" small @click="enableItem(item)" v-bind="attrs" v-on="on"> mdi-check-circle </v-icon>
            </template>
            <span>启用</span>
          </v-tooltip>
        </template>
      </v-data-table>
        </div>
      </div>
      <!--导入弹窗-->
      <v-dialog v-model="auditDialog" width="600">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2"
            >导入业务事项</v-card-title
          >
          <v-card-text>
            <v-container>
              <v-row>
                <v-col>
                  <v-file-input
                    truncate-length="15"
                    label="选择excel"
                    small-chips
                    dense
                    v-model="importFile"
                  ></v-file-input>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn color="primary" text @click="handleImport"> 确认 </v-btn>
            <v-btn color="primary" text @click="downloadTemplate">
              下载模板
            </v-btn>
            <v-btn text @click="hideAudit"> 取消 </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!--修改弹窗-->
      <v-dialog v-model="edit.dialog" width="600">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2"
          >修改业务事项</v-card-title
          >
          <v-card-text>
            <v-container>
              <v-row>
                <v-col>
                  <v-text-field label="事项编号" v-model="edit.item.itemCode" readonly></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field label="业务事项" v-model="edit.item.itemName"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field label="维保内容" v-model="edit.item.wbContent"></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn color="primary" text @click="saveItem"> 保存 </v-btn>
            <v-btn text @click="edit.dialog = false"> 取消 </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!--复检比例弹窗-->
      <v-dialog v-model="ratio.dialog" width="600">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2"
          >复检比例定义</v-card-title
          >
          <v-card-text>
            <v-form v-model="valid" ref="ratioForm">
            <v-card v-for="(subject,index) in ratio.subjectList" :key="index" flat>
              <v-card-title>{{subject.subjectName}}</v-card-title>
              <v-card-text>
                <v-row no-gutters align="center" justify="space-around">
                  <v-col cols="2" style="text-align: right">
                    <label>工程主管：</label>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field outlined dense v-model="ratio.ratioList[subject.id + '_3']" placeholder="请录入复检比例" suffix="%" :rules="[rules.required, rules.number]"></v-text-field>
                  </v-col>
                  <v-col cols="2" style="text-align: right">
                    <label>工程经理：</label>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field outlined dense v-model="ratio.ratioList[subject.id + '_2']" placeholder="请录入复检比例" suffix="%" :rules="[rules.required, rules.number]"></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
            </v-form>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn color="primary" text @click="saveRatio"> 保存 </v-btn>
            <v-btn text @click="ratio.dialog = false"> 取消 </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </div>
</template>

<script>
import {default as downloadUtil} from "@/util/downloadUtil";
import PlanItemApi from "@/api/pd/plan/PlanItem";
import {default as PermissionApi} from "@/api/smp/auth/Permission";
export default {
  name: 'Pd-Manager-Plan-Item',
  props: {
    page: {
      type: Object,
      default: null,
    }
  },
  data() {
    return {
      rules: {
        required: value => !!value || '必填.',
        number: value => ((!value && value != 0)||(!isNaN(parseFloat(value)) && value > 0)) || '只能输入数字',
      },
      tab: null,
      buttonPriviledgeList: [],
      filter: {
        itemCode: "",
        name: "",
        pageNum: 1,
        pageSize: 15,
      },
      headers: [
        {
          text: "事项编号",
          value: "itemCode",
          sortable: false,
          width: 65,
          divider: true,
          groupable: false
        },
        {
          text: "所属科目",
          value: "subjectName",
          sortable: false,
          width: 100,
          divider: true,
        },
        {
          text: "业务事项",
          align: "start",
          sortable: false,
          value: "itemName",
          width: 120,
          divider: true,
          groupable: false
        },
        {
          text: "自维/外委",
          align: "start",
          sortable: false,
          value: "type",
          width: 80,
          divider: true,
          groupable: false
        },
        {
          text: "维保内容",
          align: "start",
          sortable: false,
          value: "wbContent",
          width: 80,
          divider: true,
          groupable: false
        },
        {
          text: "标准次数",
          align: "start",
          sortable: false,
          value: "freq",
          width: 80,
          divider: true,
          groupable: false
        },
        {
          text: "周期",
          align: "start",
          sortable: false,
          value: "cycle",
          width: 80,
          divider: true,
          groupable: false
        },
        {
          text: "状态",
          align: "start",
          sortable: false,
          value: "status",
          width: 80,
          divider: true,
          groupable: false
        },
        {
          text: "修改人",
          align: "start",
          sortable: false,
          value: "updateBy",
          width: 80,
          divider: true,
          groupable: false
        },
        {
          text: "最后修改时间",
          align: "start",
          sortable: false,
          value: "updateTime",
          width: 150,
          divider: true,
          groupable: false
        },
        {
          text: "操作",
          align: "start",
          sortable: false,
          value: "actions",
          width: 150,
          divider: true,
          groupable: false
        },
      ],
      desserts: [],
      loading: false,
      totalDesserts: 0,
      valid: false,
      auditDialog: false,
      checkId: null,
      btnDisabled: false,
      importFile: undefined,
      edit:{
        item: {},
        dialog:false,

      },
      ratio:{
        dialog:false,
        subjectList:[],
        ratioList:{},
      }
    };
  },
  mounted() {
    this.getDataFromApi();
    this.getSubjectList();
    this.getButtonPriviledge();
  },
  methods: {
    // 点击审批
    clickAudit(checkId) {
      this.auditDialog = true;
      this.checkId = checkId;
    },
    hideAudit() {
      this.auditDialog = false;
      this.checkId = null;
    },
    handleSearch() {
      this.filter.pageNum = 1
      this.getDataFromApi();
    },
    handleResetSearch() {
      this.filter = {
        code: "",
        name: "",
        pageNum: 1,
        pageSize: 15,
      };
      this.getDataFromApi();
    },
    handlePageChanged(pageNum) {
      this.filter.pageNum = pageNum;
      this.getDataFromApi();
    },
    handlePageSizeChanged(pageSize) {
      if (pageSize == -1) {
        pageSize = 100;
      }
      this.filter.pageNum = 1;
      this.filter.pageSize = pageSize;
      this.getDataFromApi();
    },
    getQueryParams(query) {
      return query;
    },
    async getDataFromApi() {
      let me = this;
      me.loading = true;
      let queryUserResp = await PlanItemApi.list(me.filter);
      console.log("load user returned;");
      console.log(queryUserResp);
      let data = queryUserResp.data;
      if (!data || !data.code || data.code != 200) {
        let msg = data.msg;
        msg = !msg || msg == "" ? "获取系统版本情况失败" : msg;
        me.loading = false;
        throw new Error(msg);
      }
      if (!data.data || !data.data.rows) {
        me.loading = false;
        throw new Error("获取系统版本情况失败(无会话数据)");
      }
      me.loading = false;
      me.desserts = data.data.rows;
      me.totalDesserts = data.data.total;
    },
    async exportData() {
      let me = this;
      let res = await PlanItemApi.exportData();
      downloadUtil.downloadByBlob({ res: res.data, fileName: "导出结果.xlsx" });
    },
    doImport() {
      this.auditDialog = true;
    },
    async handleImport() {
      let me = this;
      let file = me.importFile;
      if (!file || !file.size) {
        me.$dialog.error({
          text: "文件必传",
          title: "操作失败",
        });
        return;
      }
      let res = await PlanItemApi.importData(file);
      console.log("导入结果", res);
      if (res.data.code === 200) {
        if(res.data.data){
          me.$dialog.error({
            text: res.data.data,
            title: "操作失败",
          });
        }else{
          me.$dialog.info({
            text: res.data.msg,
            title: "操作成功",
          });
        }
        me.getDataFromApi();
      } else {
        me.$dialog.error({
          text: res.data.msg + ':' + res.data.msg_detail,
          title: "操作失败",
        });
      }
      me.hideAudit();
      me.importFile = undefined;
    },
    async downloadTemplate() {
      let me = this;
      let res = await PlanItemApi.importTemplate();
      downloadUtil.downloadByBlob({ res: res.data, fileName: "导入模板.xlsx" });
    },
    doExport() {
      let me = this;
      me.exportData();
    },
    getButtonPriviledge(){
      console.log('this.page',this.page)
      let menuId = this.page.id
      let me = this
      PermissionApi.queryButtonPriviledge(menuId,null).then(resp=>{
        PermissionApi.handleResponse(resp, me, function (data){
          me.buttonPriviledgeList = data.buttonPriviledges
          console.log('buttonPriviledgeList',me.buttonPriviledgeList)
        })
      })
    },
    _hasButtonPermission(name) {
      let buttonPriviledgeList = this.buttonPriviledgeList;
      let hasButton = false;
      for (let i = 0; i < buttonPriviledgeList.length; i++) {
        if (buttonPriviledgeList[i].name == name) {
          if (buttonPriviledgeList[i].hasPriviledge == "Y") {
            return true;
          } else {
            return false;
          }
        }
      }
      return false;
    },
    async disableItem(item) {
      let me = this;
      let confirm = await me.$dialog.confirm({
        text: "确认停用业务事项吗？",
        title: "提示",
      });
      if (confirm) {
        let res = await PlanItemApi.disable(item.id);
        if (res.data.code === 200) {
          me.$dialog.info({
            text: res.data.msg,
            title: "操作成功",
          });
          me.getDataFromApi();
        } else {
          me.$dialog.error({
            text: res.data.msg,
            title: "操作成功",
          });
        }
      }
    },
    async enableItem(item) {
      let me = this;
      let confirm = await me.$dialog.confirm({
        text: "确认启用业务事项吗？",
        title: "提示",
      });
      if (confirm) {
        let res = await PlanItemApi.enable(item.id);
        if (res.data.code === 200) {
          me.$dialog.info({
            text: res.data.msg,
            title: "操作成功",
          });
          me.getDataFromApi();
        } else {
          me.$dialog.error({
            text: res.data.msg,
            title: "操作成功",
          });
        }
      }
    },
    groupToggle(group){
      this.$set(this.$refs.data.openCache, group, !this.$refs.data.openCache[group])
    },
    getHeadTextByValue(value){
      let head = this.headers.filter(head=>{return head.value == value});
      return head[0].text;
    },
    async getSubjectList() {
      let res = await PlanItemApi.listSubject();
      if (res.data.code === 200) {
        this.ratio.subjectList = res.data.data;
      } else {
        me.$dialog.error({
          text: res.data.msg,
          title: "操作失败",
        });
      }
    },
    async editItem(item) {
      this.edit.item = Object.assign({}, item);
      this.edit.dialog = true;
    },
    async saveItem() {
      let res = await PlanItemApi.edit(this.edit.item);
      if (res.data.code === 200) {
        this.$dialog.info({
          text: res.data.msg,
          title: "操作成功",
        });
        this.edit.dialog = false;
        this.getDataFromApi();
      } else {
        this.$dialog.error({
          text: res.data.msg +':'+ res.data.msg_detail,
          title: "操作失败",
        });
      }
    },
    async doRatio() {
      let res = await PlanItemApi.listRatio();
      if (res.data.code === 200) {
        let list = res.data.data;
        for(let ratio of list){
          this.ratio.ratioList[ratio.subjectId + '_' + ratio.roleId] = ratio.reInspecRatio;
        }
        this.ratio.dialog = true;
      } else {
        this.$dialog.error({
          text: res.data.msg + ':' + res.data.msg_detail,
          title: "操作失败",
        });
      }
    },
    async saveRatio() {
      let formValid = this.$refs.ratioForm.validate();
      if (formValid) {
        console.log(this.ratio.ratioList);
        let list = [];
        for (let key in this.ratio.ratioList) {
          let ids = key.split('_');
          let ratio = {subjectId: ids[0], roleId: ids[1]};
          ratio.reInspecRatio = this.ratio.ratioList[key];
          list.push(ratio);
        }
        let res = await PlanItemApi.saveRatio(list);
        if (res.data.code === 200) {
          this.$dialog.info({
            text: res.data.msg,
            title: "操作成功",
          });
          this.ratio.dialog = false;
        } else {
          this.$dialog.error({
            text: res.data.msg +':'+ res.data.msg_detail,
            title: "操作失败",
          });
        }
      }
    }
  },
};
</script>
<style scoped>
.padding-bottom {
  padding: 0 16px;
  /**padding-bottom: 12px;**/
}
.padding-top {
  padding-top: 30px;
}
.margin-right {
  margin-right: 12px;
}
</style>